import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import Switch from "antd/es/switch";

import styles from "./Header.module.scss";

interface Props {
  checked?: boolean;
  description: string;
  onChange?: (value: boolean) => void;
  title: string;
}

const Header: React.FC<Props> = ({ checked, description, onChange, title }) => {
  return (
    <div>
      <div>
        <Row justify="space-between">
          <Col className={styles.title} span={20}>
            {title}
          </Col>
          <Col span={4}>
            <Row justify="end">
              <Col>
                <Switch checked={checked} onChange={onChange} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div className={styles.text}>{description}</div>
    </div>
  );
};

export default Header;
